import { render, staticRenderFns } from "./DetialOfLiteracy.vue?vue&type=template&id=70f5e8e0&scoped=true"
import script from "./DetialOfLiteracy.vue?vue&type=script&lang=js"
export * from "./DetialOfLiteracy.vue?vue&type=script&lang=js"
import style0 from "./DetialOfLiteracy.vue?vue&type=style&index=0&id=70f5e8e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f5e8e0",
  null
  
)

export default component.exports